/* =====================================================
   Black Build Project
   Global JavaScript
===================================================== */

(() => {
  'use strict';

  function initializeBbpHeader(root = document) {
    const headers = root.querySelectorAll('[data-bbp-header]');

    headers.forEach((header) => {
      if (header.dataset.bbpInitialized === 'true') {
        return;
      }

      const toggle = header.querySelector('[data-bbp-menu-toggle]');
      const menu = header.querySelector('[data-bbp-menu]');

      if (!toggle || !menu) {
        return;
      }

      header.dataset.bbpInitialized = 'true';

      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const willOpen = !header.classList.contains('is-open');

        header.classList.toggle('is-open', willOpen);
        menu.classList.toggle('is-open', willOpen);

        toggle.setAttribute(
          'aria-expanded',
          willOpen ? 'true' : 'false'
        );
      });

      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          header.classList.remove('is-open');
          menu.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
          return;
        }

        header.classList.remove('is-open');
        menu.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initialize() {
    initializeBbpHeader(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {
      once:true
    });
  } else {
    initialize();
  }

  /* Shopifyテーマエディタでセクションが再読み込みされた場合 */
  document.addEventListener('shopify:section:load', (event) => {
    initializeBbpHeader(event.target);
  });
})();